export default __webpack_public_path__ + "static/media/US.bbbd9f52.svg";